import React, { useEffect } from "react";

const Toast = ({ message, type = "info", onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => onClose(), 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={`custom-toast ${type}`}>
            <span>{message}</span>
        </div>
    );
};

export default Toast;
